<template>
  <parameter-router-auth-container :isInsideDialog="isInsideDialog" :initialAuthType="initialAuthType" id="checkout-authentication" />
</template>

<script>
export default {
  name: 'checkout-authentication',
  props: {
    isInsideDialog: Boolean,
    initialAuthType: String
  }
}
</script>
